/**
 * Property Form - Basic Info Section
 */
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const PROPERTY_TYPES = ["Casa", "Apartamento", "Terreno", "Oficina", "Local Comercial", "Bodega", "Finca"];
const TRANSACTION_TYPES = ["Venta", "Alquiler", "Venta y Renta"];

const PropertyBasicInfo = ({ 
  name, setName, 
  propertyType, setPropertyType, 
  transactionType, setTransactionType, 
  priceUsd, setPriceUsd, 
  priceRent, setPriceRent,
  areaM2, setAreaM2 
}) => {
  const isVentaYRenta = transactionType === "Venta y Renta";
  
  return (
    <section className="bg-[#121212] border border-white/5 p-6 space-y-6">
      <h2 className="text-lg text-white font-medium">Información Básica</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="md:col-span-2">
          <label className="block text-sm text-[#A3A3A3] mb-2">Nombre de la Propiedad *</label>
          <Input 
            value={name} 
            onChange={(e) => setName(e.target.value)} 
            placeholder="Ej: Residencia de Lujo en Cayalá" 
            className="h-12 bg-black/40 border-white/10 text-white"
            required
          />
        </div>
        <div>
          <label className="block text-sm text-[#A3A3A3] mb-2">Tipo de Propiedad *</label>
          <Select value={propertyType} onValueChange={setPropertyType}>
            <SelectTrigger className="h-12 bg-black/40 border-white/10 text-white" data-testid="property-type-select">
              <SelectValue placeholder="Seleccionar" />
            </SelectTrigger>
            <SelectContent className="bg-[#121212] border-white/10">
              {PROPERTY_TYPES.map(type => (
                <SelectItem key={type} value={type}>{type}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div>
          <label className="block text-sm text-[#A3A3A3] mb-2">Tipo de Transacción *</label>
          <Select value={transactionType} onValueChange={setTransactionType}>
            <SelectTrigger className="h-12 bg-black/40 border-white/10 text-white" data-testid="transaction-type-select">
              <SelectValue placeholder="Seleccionar" />
            </SelectTrigger>
            <SelectContent className="bg-[#121212] border-white/10">
              {TRANSACTION_TYPES.map(type => (
                <SelectItem key={type} value={type}>{type}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        
        {/* Price fields - conditional based on transaction type */}
        {isVentaYRenta ? (
          <>
            <div>
              <label className="block text-sm text-[#A3A3A3] mb-2">Precio de Venta (USD) *</label>
              <Input 
                type="number" 
                value={priceUsd} 
                onChange={(e) => setPriceUsd(e.target.value)} 
                placeholder="250000" 
                className="h-12 bg-black/40 border-white/10 text-white"
                data-testid="price-sale-input"
                required
              />
            </div>
            <div>
              <label className="block text-sm text-[#A3A3A3] mb-2">Precio de Renta Mensual (USD) *</label>
              <Input 
                type="number" 
                value={priceRent} 
                onChange={(e) => setPriceRent(e.target.value)} 
                placeholder="1500" 
                className="h-12 bg-black/40 border-white/10 text-white"
                data-testid="price-rent-input"
                required
              />
            </div>
          </>
        ) : (
          <div>
            <label className="block text-sm text-[#A3A3A3] mb-2">
              Precio {transactionType === "Alquiler" ? "Mensual" : ""} (USD) *
            </label>
            <Input 
              type="number" 
              value={priceUsd} 
              onChange={(e) => setPriceUsd(e.target.value)} 
              placeholder={transactionType === "Alquiler" ? "1500" : "250000"}
              className="h-12 bg-black/40 border-white/10 text-white"
              data-testid="price-input"
              required
            />
          </div>
        )}
        
        <div>
          <label className="block text-sm text-[#A3A3A3] mb-2">Área (m²) *</label>
          <Input 
            type="number" 
            value={areaM2} 
            onChange={(e) => setAreaM2(e.target.value)} 
            placeholder="350" 
            className="h-12 bg-black/40 border-white/10 text-white"
            required
          />
        </div>
        
        {/* Info message for Venta y Renta */}
        {isVentaYRenta && (
          <div className="md:col-span-2 p-4 bg-blue-500/10 border border-blue-500/20 rounded-lg">
            <p className="text-blue-400 text-sm">
              Se crearán dos publicaciones: una para Venta y otra para Alquiler, con la misma información pero precios diferentes.
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default PropertyBasicInfo;
